/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Dusty_Free_Eel_BaskInputs */

const en_dusty_free_eel_bask = /** @type {(inputs: Dusty_Free_Eel_BaskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}`)
};

const de_dusty_free_eel_bask = /** @type {(inputs: Dusty_Free_Eel_BaskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}`)
};

/**
* | output |
* | --- |
* | "{date}" |
*
* @param {Dusty_Free_Eel_BaskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dusty_free_eel_bask = /** @type {((inputs: Dusty_Free_Eel_BaskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dusty_Free_Eel_BaskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dusty_free_eel_bask(inputs)
	return de_dusty_free_eel_bask(inputs)
});